import React from 'react'
import HeroImage from "../../assets/polocies-compliance-operation-method-system.jpg";

const ComplianceHero = () => {
  return (
    <div className='ComplianceHero'>
      <div className="HeroPrivacyPolicy">
        <main className="max-w-7xl mx-auto px-4 py-16 md:py-20">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Left Column */}
            <div>
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Committed to Compliance  <br />
                <div className="italic font-bold text-blue-600">& Security.</div>
              </h1>
              <p className="text-gray-600 mb-5 max-w-lg">
                At Pay363, we follow the highest industry standards and regulatory frameworks to ensure your transactions are secure and your data is protected. From KYC and AML policies to data privacy laws like NDPR and GDPR, our systems are built with full compliance at their core.
              </p>

              <div className="mt-5">
                <p>✅ NDPR/GDPR Compliant & Data-Secure</p>
                <p>✅ Adheres to KYC & AML Regulations</p>
                <p>✅ Trusted by Financial Institutions & Government Agencies</p>
              </div>

            </div>

            {/* Right Column */}
            <div className="space-y-4">
              <div className="bg-gray-100 rounded-3xl">
                <img
                  src={HeroImage}
                  alt="Credit cards"
                  className="w-full h-auto rounded-2xl"
                />
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}

export default ComplianceHero
